export const TEST_ID = 'connectionsIcon';
